import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { api } from '../../api/client';
import type { PublicOwnerBranding } from '@pay/shared';
import { OwnerHeader } from '../../components/OwnerHeader';
import { CustomerFooter } from '../../components/CustomerFooter';
import { SalgsvilkarTekst } from '../../components/SalgsvilkarTekst';

// Kundesiden med salgsvilkårene: /vilkar/:ownerId fyller inn eierens navn, org.nr., adresse og e-post. /vilkar alene
// (og ukjent eier) gir den generelle varianten. Teksten står i components/SalgsvilkarTekst.tsx, som også Pay-admin
// viser (Salgsvilkår i menyen).
export default function Terms() {
  const { ownerId } = useParams<{ ownerId?: string }>();
  const [owner, setOwner] = useState<PublicOwnerBranding | null>(null);
  const [loading, setLoading] = useState(Boolean(ownerId));

  useEffect(() => {
    if (!ownerId) return;
    api
      .get<PublicOwnerBranding>(`/api/public/owners/${encodeURIComponent(ownerId)}`)
      .then(setOwner)
      .catch(() => setOwner(null))
      .finally(() => setLoading(false));
  }, [ownerId]);

  useEffect(() => {
    document.title = owner ? `Salgsvilkår – ${owner.name}` : 'Salgsvilkår';
  }, [owner]);

  if (loading) {
    return (
      <div className="min-h-full flex items-center justify-center">
        <Loader2 className="animate-spin text-slate-400" size={32} />
      </div>
    );
  }

  return (
    <div className="min-h-full bg-slate-100">
      {owner ? (
        <OwnerHeader owner={owner} />
      ) : (
        <header className="px-6 py-5 bg-slate-800">
          <div className="max-w-2xl mx-auto text-white text-xl font-semibold">Salgsvilkår</div>
        </header>
      )}

      <main className="max-w-2xl mx-auto p-6">
        <SalgsvilkarTekst owner={owner} />

        <CustomerFooter owner={owner} hideTermsLink />
      </main>
    </div>
  );
}
